import React from 'react'

export default function Navbar() {
    return (
        <div className="navbar bg-base-100/10 sticky top-0 backdrop-blur-sm z-10 px-[10vw] max-sm:px-[5vw]">
            <div className="navbar-start">
                <a href="/" className="btn btn-ghost text-xl">
                    CSS Priority
                </a>
            </div>
            <div className="navbar-end">
                <a href="#docs" className="btn bg-primary">
                    Docs
                </a>
            </div>
        </div>
    )
}
